import { render, staticRenderFns } from "./PFRPModal.vue?vue&type=template&id=069fa801&scoped=true"
import script from "./PFRPModal.vue?vue&type=script&lang=js"
export * from "./PFRPModal.vue?vue&type=script&lang=js"
import style0 from "./PFRPModal.vue?vue&type=style&index=0&id=069fa801&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069fa801",
  null
  
)

export default component.exports